module.exports = __webpack_public_path__ + "static/media/covid19.2c34cc69.jpg";